export const stepsFooterSx = {
  gridRoot: {
    justifyContent: "space-between",
    alignItems: "center",
    p: 2,
    position: "relative",
  },
  leftGrid: {
    display: "flex",
    justifyContent: "flex-start",
  },
  rightGrid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 2,
  },
  errorBox: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  sampleBox: {
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    flexDirection: { xs: "column", md: "row" },
    gap: 0.5,
    textAlign: "center",
    pointerEvents: "none",
  },
  sampleText: {
    fontSize: { xs: 14, sm: 18 },
  },
  sampleLink: {
    fontWeight: 700,
    cursor: "pointer",
    pointerEvents: "auto",
    fontSize: { xs: 14, sm: 18 },
  },
};
